var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerioperativeMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BEFD0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.052,26.625H6.021h7.656l0,0h2.43 c1.709-12.816-1.424-14.319-1.424-14.319c-1.362-1.222-4.655-1.519-4.655-1.519c-2.715,0.439-4.23,1.519-4.23,1.519 c-1.859,1.247-1.721,4.889-1.721,4.889l-0.002,9.43H6.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.618,14.633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.718,14.633"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.907,17.186"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.71,9.365 c0.167,0.035,0.337,0.054,0.508,0.051c0.727-0.013,1.407-0.117,2.068-0.337c0.066,0.989,0.35,2.113,0.58,2.572 c0.448,0.898-2.049,0.843-2.049,0.843s-2.148-0.061-1.567-0.91C8.775,10.815,8.689,9.634,8.71,9.365z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M10.68,10.239c-0.423,0.157-0.87,0.149-1.295,0.011c-0.293-0.095-0.513-0.294-0.716-0.439 c0.11-0.561,0.044-0.489,0.044-0.489l2.498-2.01c0,0,0,1.256,0.146,2.541C11.14,10.041,11.151,10.065,10.68,10.239z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.004,7.001 C6.998,6.526,7.14,6.14,7.439,6.136c0.052-0.001,0.105,0.011,0.157,0.032c-0.011-0.132-0.018-0.228-0.02-0.268 C7.575,5.883,7.574,5.868,7.575,5.852c0-0.003,0-0.008,0-0.011c0,0,0,0,0,0c0-0.009,0.001-0.018,0.001-0.029 c0-0.004,0-0.008,0.001-0.012c0-0.009,0.001-0.018,0.001-0.028c0-0.007,0.001-0.015,0.002-0.023 C7.58,5.739,7.581,5.73,7.581,5.72c0.001-0.01,0.002-0.022,0.003-0.033C7.585,5.679,7.586,5.67,7.587,5.661 C7.588,5.647,7.59,5.633,7.591,5.619c0.001-0.009,0.002-0.017,0.003-0.026C7.596,5.577,7.598,5.56,7.601,5.543 c0.001-0.008,0.002-0.016,0.003-0.025C7.607,5.499,7.61,5.48,7.613,5.46c0.001-0.008,0.002-0.015,0.004-0.023 c0.004-0.021,0.008-0.043,0.012-0.066C7.63,5.363,7.632,5.356,7.633,5.348c0.005-0.023,0.01-0.047,0.015-0.071 C7.65,5.269,7.651,5.262,7.653,5.254c0.006-0.025,0.012-0.05,0.019-0.076c0.002-0.007,0.004-0.014,0.005-0.022 C7.684,5.13,7.692,5.103,7.7,5.076c0.002-0.007,0.004-0.014,0.006-0.022c0.008-0.027,0.017-0.055,0.026-0.083 c0.002-0.007,0.005-0.015,0.007-0.022c0.01-0.028,0.02-0.057,0.031-0.086c0.003-0.007,0.005-0.014,0.008-0.022 c0.011-0.029,0.023-0.058,0.035-0.087C7.817,4.747,7.82,4.74,7.823,4.733c0.013-0.029,0.026-0.059,0.04-0.088 C7.866,4.637,7.87,4.63,7.873,4.622c0.014-0.029,0.03-0.058,0.045-0.087C7.922,4.528,7.926,4.52,7.93,4.513 c0.016-0.029,0.033-0.058,0.05-0.086C7.985,4.419,7.99,4.411,7.994,4.403C8.012,4.375,8.031,4.347,8.05,4.319 c0.005-0.008,0.01-0.016,0.016-0.024c0.019-0.028,0.04-0.055,0.061-0.082C8.132,4.206,8.138,4.198,8.144,4.19 C8.165,4.163,8.187,4.137,8.21,4.111c0.007-0.008,0.014-0.016,0.021-0.024c0.023-0.025,0.047-0.05,0.071-0.074 C8.31,4.004,8.318,3.996,8.326,3.988c0.024-0.024,0.05-0.047,0.076-0.069C8.412,3.91,8.421,3.901,8.43,3.893 C8.456,3.871,8.484,3.85,8.511,3.829c0.011-0.008,0.021-0.017,0.032-0.025c0.028-0.02,0.057-0.04,0.087-0.059 c0.012-0.008,0.023-0.016,0.036-0.024c0.03-0.019,0.061-0.036,0.092-0.053C8.771,3.66,8.784,3.651,8.798,3.644 C8.83,3.628,8.863,3.612,8.895,3.597c0.015-0.007,0.03-0.015,0.046-0.022C8.974,3.56,9.009,3.547,9.044,3.534 c0.017-0.007,0.033-0.014,0.05-0.02C9.129,3.502,9.165,3.491,9.201,3.48c0.019-0.006,0.038-0.013,0.058-0.018 c0.037-0.01,0.075-0.019,0.113-0.028C9.393,3.43,9.413,3.424,9.434,3.42c0.039-0.008,0.08-0.014,0.121-0.021 c0.022-0.004,0.043-0.008,0.066-0.011c0.043-0.006,0.089-0.01,0.134-0.014c0.022-0.002,0.043-0.005,0.065-0.007 C9.89,3.362,9.96,3.358,10.033,3.357c0.07-0.001,0.138,0,0.205,0.003c0.022,0.001,0.043,0.003,0.064,0.004 c0.044,0.003,0.088,0.006,0.13,0.01c0.024,0.003,0.048,0.006,0.072,0.009c0.037,0.005,0.075,0.01,0.111,0.016 c0.024,0.004,0.048,0.009,0.071,0.014c0.034,0.007,0.068,0.014,0.101,0.022c0.023,0.006,0.046,0.012,0.068,0.018 c0.032,0.009,0.063,0.018,0.094,0.027c0.022,0.007,0.043,0.014,0.063,0.021c0.03,0.01,0.06,0.021,0.089,0.033 c0.02,0.008,0.039,0.016,0.058,0.024c0.029,0.012,0.057,0.025,0.085,0.039c0.017,0.008,0.035,0.016,0.052,0.025 c0.029,0.015,0.056,0.03,0.084,0.046c0.015,0.008,0.03,0.017,0.044,0.025c0.029,0.018,0.058,0.036,0.086,0.055 c0.011,0.008,0.023,0.015,0.033,0.022c0.034,0.024,0.067,0.049,0.099,0.074c0.004,0.003,0.008,0.006,0.011,0.009 c0.072,0.059,0.139,0.121,0.2,0.185c0.006,0.006,0.011,0.012,0.017,0.019c0.024,0.026,0.047,0.052,0.07,0.078 c0.008,0.009,0.015,0.018,0.022,0.027c0.02,0.024,0.039,0.049,0.057,0.073c0.008,0.01,0.015,0.021,0.023,0.031 c0.017,0.024,0.034,0.048,0.05,0.072c0.007,0.011,0.014,0.022,0.021,0.033c0.015,0.024,0.03,0.048,0.044,0.072 c0.007,0.011,0.013,0.022,0.019,0.033c0.014,0.024,0.027,0.049,0.04,0.073c0.006,0.011,0.012,0.022,0.017,0.033 c0.013,0.025,0.025,0.05,0.037,0.075c0.005,0.01,0.01,0.02,0.014,0.031c0.012,0.026,0.023,0.053,0.034,0.079 c0.004,0.008,0.007,0.017,0.011,0.025c0.012,0.029,0.023,0.058,0.034,0.087c0.002,0.005,0.004,0.01,0.006,0.016 c0.025,0.069,0.047,0.138,0.066,0.203c0,0.002,0.001,0.003,0.001,0.005c0.009,0.03,0.017,0.06,0.024,0.089 c0.002,0.009,0.004,0.017,0.006,0.026c0.005,0.022,0.011,0.043,0.015,0.064c0.002,0.011,0.005,0.022,0.007,0.033 c0.004,0.017,0.007,0.035,0.011,0.052c0.002,0.012,0.005,0.024,0.007,0.035c0.003,0.015,0.005,0.03,0.008,0.044 c0.002,0.012,0.004,0.024,0.006,0.036c0.002,0.012,0.004,0.024,0.006,0.035c0.002,0.013,0.004,0.026,0.005,0.038 c0.001,0.009,0.002,0.018,0.003,0.027c0.002,0.013,0.003,0.026,0.005,0.038c0.001,0.006,0.001,0.012,0.002,0.018 c0.002,0.014,0.003,0.027,0.004,0.039c0,0,0,0.001,0,0.001l0,0c0.005,0.048,0.007,0.086,0.008,0.109 c0.001,0.016,0.001,0.031,0,0.047c-0.002,0.04-0.006,0.136-0.014,0.269c0.052-0.022,0.105-0.035,0.157-0.036 c0.299-0.004,0.451,0.379,0.458,0.853c0.006,0.449-0.444,0.824-0.745,0.865c-0.05,0.447-0.127,0.83-0.193,0.991 c-0.29,0.707-1.365,1.269-2.079,1.278c-0.714,0.009-1.577-0.36-2.149-1.222C7.895,8.687,7.834,8.291,7.772,7.846 C7.47,7.812,7.01,7.45,7.004,7.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M8.174,5.3c0,0-0.442,1.439-0.41,2.598l-0.24-1.677c0,0-0.327-0.437,0.031-0.662l0.326-0.396 l0.15-0.022l0.091,0.029L8.174,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M11.939,5.139c0,0,0.445,1.68,0.413,2.811l0.261-1.907c0,0,0.315-0.445-0.049-0.661l-0.336-0.387 l-0.151-0.018l-0.09,0.031L11.939,5.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BEFD0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.574,5.569c0,0,1.814-1.278,4.901-0.176 c0,0,1.007-1.31,0.1-2.341C11.668,2.021,9.16,2.427,9.16,2.427S5.811,2.676,7.574,5.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.012,6.339l0.387,1.262 c0,0,0.035,0.289-0.227,0.306H9.757"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2"
    },
    d: "M10.777,8.572c0.083,0.055,0.164,0.111,0.157,0.198c-0.01,0.135-0.028,0.321-0.054,0.339 c-0.019,0.013-0.11,0.027-0.201,0.039c-0.121,0.016-0.239-0.035-0.285-0.122l-0.011-0.02c-0.017-0.033-0.058-0.053-0.102-0.051 l-0.4,0.022C9.845,8.978,9.811,8.997,9.793,9.025l0,0C9.735,9.12,9.595,9.169,9.467,9.138C9.392,9.12,9.325,9.099,9.314,9.082 C9.298,9.055,9.32,8.845,9.337,8.699c0.01-0.087,0.089-0.16,0.197-0.184C9.717,8.475,10.47,8.369,10.777,8.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.637,8.735c0,0,0.604,0.245,0.98-0.035"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BEFD0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.8,7.767c0,0,0.278,0.25,1.351-0.001 c0.716-0.167,0.768-0.964,1.728-0.183c0,0,0.684,0.367,1.375-0.033c0,0,0.33,0.902-0.054,1.6c0,0-0.444,1.014-2.079,1.086 c0,0-1.607,0.12-2.231-1.402C7.89,8.834,7.578,8.231,7.8,7.767z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 6.618,
    y1: 26.625,
    x2: 6.618,
    y2: 15.342
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 13.718,
    y1: 26.625,
    x2: 13.718,
    y2: 15.342
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.745,27.009H1.867v-3.046h10.877 c1.012,0,1.833,0.682,1.833,1.523l0,0C14.577,26.327,13.757,27.009,12.745,27.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.745,28.299H1.867v-3.046h10.877 c1.012,0,1.833,0.682,1.833,1.523l0,0C14.577,27.617,14.141,28.606,12.745,28.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.18,11.711 c-0.362,0.532-1.206,0.679-1.521,1.058c-0.076,0.091,0.321,0.463,0.253,0.55c-0.624,0.793-0.872,1.399,0.039,2.372 c0.121,0.129,0.029,0.032,0.189,0.191c-0.33,0.582-0.596,0.904-0.596,0.904l-0.937,0.653l0.871,0.897l1.101,1.135 c0.596-0.707,1.652-2.013,2.146-2.663c0.88,0.017,1.782-0.248,2.492-0.938c1.594-1.547,1.396-3.163,0.281-4.311 C25.383,10.411,23.525,9.734,22.18,11.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.936,9.079 c0,1.701-1.379,3.081-3.08,3.081s-3.081-1.379-3.081-3.081c0-1.701,1.379-3.08,3.081-3.08S20.936,7.378,20.936,9.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.972,20.469l-7.557,7.334l-3.888-4.006 l6.679-6.481c1.349-1.309,3.504-1.277,4.813,0.072l0,0C22.856,18.252,22.835,19.631,21.972,20.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M22.178,10.247c0,0-0.949,1.715,2.139,2.204c0,0,1.595,0.323-0.271,1.622l0.437,0.523 c0,0,0.535-1.159,0.916-0.555c0,0,0.603,0.867-1.335,1.5c0,0-1.349,0.699-1.094,1.859c0,0,2.053,0.39,4.217-1.992 c0,0,2.365-2.528-0.695-4.889C26.492,10.52,23.461,7.925,22.178,10.247z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "14.426,27.815 29.326,13.355  30.133,14.186 14.196,29.652 1.867,29.652 1.867,28.405 13.698,28.435  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.144,26.268c0,0-1.616,0.367-2.204,0.517 c-2.132,0.546-1.817,1.609-1.817,1.609s2.835,0.04,4.021,0.04V26.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.19,20.197l-8.461,8.074l-2.641-1.728 l8.549-8.976c0.726-0.705,1.887-0.687,2.592,0.039l0,0C22.934,18.332,22.916,19.492,22.19,20.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.524,13.802c0,0,0.207,0.423,0.749,0.539"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.651,9.358 c0.16-0.206,0.26-0.461,0.26-0.742c0-0.67-0.543-1.213-1.213-1.213c-0.328,0-0.624,0.131-0.842,0.343 c-0.218-0.211-0.515-0.343-0.843-0.343c-0.67,0-1.213,0.543-1.213,1.213c0,0.389,0.186,0.731,0.471,0.953l1.59,1.59l1.643-1.643 c0.033-0.03,0.064-0.061,0.094-0.094l0.044-0.052L19.651,9.358z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.2,
      strokeMiterlimit: 10
    },
    points: "16.131,9.421 17.232,9.421  17.475,8.739 17.735,9.421 17.994,8.494 18.3,9.664 18.531,9.117 18.763,9.421 19.58,9.421  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerioperativeMedicine);
export default __webpack_public_path__ + "static/media/perioperative_medicine.33beabb229d42e5599a40d7a894398d7.svg";
export { ForwardRef as ReactComponent };